import * as React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: absolute;
  z-index: 2;
  width: 30px;
  height: 30px;
  top: 13px;
  right: 16px;
  backface-visibility: hidden;
  -webkit-tap-highlight-color: transparent;
  border-radius: 999px;
  color: var(--secondary-text-color);

  @supports (backdrop-filter: blur(10px)) {
    background-color: rgba(180, 180, 180, 0.3);
    backdrop-filter: blur(10px);
  }

  @supports not (backdrop-filter: blur(10px)) {
    background-color: #ddd;
  }

  &:active {
    background-color: #ccc;
    color: var(--primary-text-color);
  }
`;

interface Props {
  onClick: () => void;
}

export const IosCloseButton: React.FC<Props> = ({ onClick }) => {
  return (
    <Wrapper onClick={onClick}>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.28244 19.0659C8.79429 19.5541 8.79429 20.3455 9.28244 20.8337C9.7706 21.3218 10.5621 21.3218 11.0502 20.8337L15 16.8839L18.9498 20.8337C19.438 21.3219 20.2294 21.3219 20.7176 20.8337C21.2057 20.3455 21.2057 19.5541 20.7176 19.0659L16.7678 15.1161L20.9497 10.9342C21.4379 10.446 21.4379 9.65456 20.9497 9.16641C20.4615 8.67825 19.6701 8.67825 19.1819 9.16641L15 13.3483L10.8181 9.16643C10.3299 8.67828 9.53848 8.67828 9.05032 9.16643C8.56217 9.65459 8.56217 10.446 9.05032 10.9342L13.2322 15.1161L9.28244 19.0659Z"
          fill="currentColor"
        />
      </svg>
    </Wrapper>
  );
};



// WEBPACK FOOTER //
// ./src/components/iOSCloseButton.tsx